// An assistant's sign-in request survives the trip through sign-in and organization selection; only this page's own path is kept.
const KEY = 'guardianOAuthReturn';
const PREFIX = '/guardian/oauth/authorize?';

export function rememberOAuthReturn(referrer: string | null) {
  if (!referrer?.startsWith(PREFIX)) {
    return;
  }
  try {
    sessionStorage.setItem(KEY, referrer);
  } catch {
    // without storage the member lands on the dashboard and adds the connector again
  }
}

export function takeOAuthReturn(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return value?.startsWith(PREFIX) ? value : null;
  } catch {
    return null;
  }
}
